<button
[matMenuTriggerFor]="TableMenu"
valgButton
color="icon-no-highlight"
class="table-row-option-button"
[attr.aria-label]="label">
  <mat-icon
    [svgIcon]="SvgIcon.ThreeDotVertical"
    class="valgButton__icon"
  ></mat-icon>
</button>

<mat-menu #TableMenu="matMenu" class="table-menu">
  <ng-template matMenuContent>
    <button
    *ngFor="let option of itemOptions"
    (click)="onClick(option)"
    mat-menu-item>
      {{ option.title | translate : option.getTitleValue?.(data) }}
    </button>
  </ng-template>
</mat-menu>
